<div class="modal-header">
  <h3 class="mb-0">Add a document</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <app-file-upload-file-display
    [layout]="'vertical'"
    [removeFileButtonText]="'Remove'"
    [hideSelectFileButton]="true"
    [Files]="Files"
    (FileEvent)="fileUpload($event)"
    (removeFileEvent)="removeFile($event)"
  ></app-file-upload-file-display>

  @if (CompanyVendor) {
    <div class="upload-meta">
      <div class="form-group">
        <label for="docType" class="form-label" requiredAsterisk>
          File type
        </label>
        <select
          id="docType"
          class="form-select"
          [(ngModel)]="chosenCompanyVendorFileDocType"
          (change)="onFileTypeChange()"
        >
          <option selected disabled [ngValue]="null">Pick one...</option>
          @for (type of companyVendorFileDocTypes; track type) {
            <option [ngValue]="type">
              {{ type }}
            </option>
          }
        </select>
      </div>

      @if (isAdminUser()) {
        <div class="form-group">
          <label for="filePermission" class="form-label" requiredAsterisk>
            File permission
          </label>
          <select
            id="filePermission"
            class="form-select"
            [(ngModel)]="chosenVendorFilePermission"
          >
            <option selected disabled [ngValue]="null">Pick one...</option>
            @for (
              permission of companyVendorFilePermissions;
              track permission
            ) {
              <option [ngValue]="permission">
                {{ permission }}
              </option>
            }
          </select>
        </div>
      }

      @if (isAdminUser()) {
        <div class="check-group mt-0">
          <input
            id="allClients"
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="allVendorClients"
            (change)="onAllVendorClientsChange()"
          />
          <label for="allClients" class="form-check-label mt-0">
            Upload for all clients?
          </label>
        </div>
      }
    </div>
  }
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="upload()">
      Upload
    </button>
  </div>
</div>
